import {
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonImg,
  IonSpinner,
  IonText,
} from '@ionic/react';
import { useEffect, useState } from 'react';

import BackArrow from '@/assets/imgs/back-arrow.webp';
import Plane from '@/assets/imgs/plane.webp';
import { postForgotPasswdLink } from '@/redux/auth/authAPI';
import InsightService from '@/services/insights';

import styles from './LoginResend.module.scss';

interface LoginResendProps {
  username: string;
  setError: () => void;
  backBtn: () => void;
}

export default function LoginResend({
  username,
  setError,
  backBtn,
}: LoginResendProps) {
  const [loadingEmail, setLoadingEmail] = useState(false);

  const handleForgotPasswdLink = async (resend: boolean) => {
    try {
      resend && setLoadingEmail(true);
      // Responde 202 sin body: si no lanza error, el correo se ha enviado
      await postForgotPasswdLink({
        username,
      });
      InsightService.logTrace('Login - Forgot Password Link', [
        { User: username },
      ]);
    } catch (err) {
      setError();
    } finally {
      resend && setLoadingEmail(false);
    }
  };

  useEffect(() => {
    handleForgotPasswdLink(false);
  }, []);

  return (
    <>
      <IonCardHeader className={styles.resendPasswordHeader} mode="md">
        <IonCardSubtitle className={styles.accessBackPassword}>
          <IonImg src={BackArrow} className={styles.backArrow} onClick={backBtn} />
          <IonText className={styles.accessBack} onClick={backBtn}>
            Atrás
          </IonText>
        </IonCardSubtitle>
        <IonCardTitle className={styles.recoverAccessKey}>
          Recuperar clave de acceso
        </IonCardTitle>
      </IonCardHeader>
      <IonCardContent>
        <p className={styles.text}>
          Te hemos enviado un correo electrónico a
          <IonText className={styles.specialText}>
            {' '}
            la dirección asociada a tu usuario
            {' '}
          </IonText>
          para que puedas cambiar tu clave de acceso a Pepper Comercios.
        </p>
        <div className={styles.planeImg}>
          <IonImg src={Plane} />
        </div>
        <div className={styles.spam}>
          <p className={styles.spamText}>
            Si no lo encuentras echa un vistazo a tu carpeta de spam o de correo
            no deseado.
          </p>
        </div>
        <div>
          <p className={styles.resendEmail}>
            ¿No lo has recibido? Bueno, vamos a
            {loadingEmail ? <IonSpinner name="dots" color="danger" className={styles.emailSpinner} /> : (
              <IonText
                className={styles.specialText}
                onClick={() => {
                  handleForgotPasswdLink(true);
                }}
              >
                {' '}
                intentarlo de nuevo
              </IonText>
            )}
          </p>
        </div>
      </IonCardContent>
    </>
  );
}
